import {
  LetterbookType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import Text from "hardcover-ui/components/Text";
import { secondsFormat } from "lib/bookUtils";
import faBook from "icons/regular/book.svg";
import faHeadphones from "icons/regular/headphones.svg";
import Icon from "hardcover-ui/components/Icon";
import pluralize from "lib/pluralize";
import LetterbookCell from "../LetterbookCell";

export default function LengthColumn({
  letterbook,
}: {
  letterbook: LetterbookType;
}) {
  const { book } = letterbook;
  const length = book.audioSeconds ? secondsFormat(book.audioSeconds) : null;

  return (
    <LetterbookCell className="font-bold text-md whitespace-nowrap">
      <>
        <span className="flex items-center space-x-2">
          <Icon icon={faBook} size="md" />
          {book.pages ? (
            <span>
              {book.pages.toLocaleString()} {pluralize("page", book.pages)}
            </span>
          ) : (
            <Text variant="secondary">? pages</Text>
          )}
        </span>

        <span className="flex items-center space-x-2">
          <Icon icon={faHeadphones} size="md" />
          {length ? (
            <span>{length}</span>
          ) : (
            <Text variant="secondary">? duration</Text>
          )}
        </span>
      </>
    </LetterbookCell>
  );
}

export const settings = {
  key: "Length",
  title: "Length",
} as LetterlistTableColumnSettingType;
